import React from 'react';
import { detectLocation } from '../detectLocation.js';


/**
 * Detects the user's location with MaxMind or mobile browser location
 * @param suppressMobileDetection Whether to suppress location detection on mobile. Mobile location
 * detection requires the user to accept a prompt, which can be a bad experience in some cases.
 * @param useMaxMindOnMobile Whether to use MaxMind location detection on mobile (it's very inaccurate there)
 * @return Array containing the detected location (if it exists)
 */
export const useLocation = function (suppressMobileDetection = true, useMaxMindOnMobile = false) {
    const [detectedLocation, setDetectedLocation] = React.useState();

    React.useEffect(() => {
        detectLocation(setDetectedLocation, suppressMobileDetection, useMaxMindOnMobile);
    }, [suppressMobileDetection, useMaxMindOnMobile]);

    return [detectedLocation];
};
